import { render, staticRenderFns } from "./ServiceBarChart.vue?vue&type=template&id=b65f4f88&scoped=true&"
import script from "./ServiceBarChart.vue?vue&type=script&lang=js&"
export * from "./ServiceBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBarChart.vue?vue&type=style&index=0&id=b65f4f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65f4f88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VProgressCircular,VToolbar,VToolbarTitle})
